import { Form } from 'antd'
import { CustomForm } from 'components/Forms/CustomForm'
import { BTN_TXT } from 'constants/txt'
import VendorForm from '../../General/VendorForm/VendorForm'
import useDetailsForm from '../../General/DetailsForm/hooks/useDetailsForm'
import { useVendorDetailsContext } from '../../Providers/ContextProvider'
import { COUNTRIES_LIST, validateMessages } from '../../constants'
import { routes } from 'router'
import useRouter from 'hooks/useRouter'
import { ability, ACTIONS, SUBJECTS } from 'features/Permission'
import { MY_COMMUNITY_KEYS } from '../../../../constants'
import { VendorDetailsForm } from './types'
import './styles.scss'
import { FloatFooter } from '../../../../../../components/FloatFooter/FloatFooter'
import { Popup } from '../../../../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../../../../components/Button'
import Typography from '../../../../../../components/Typography/Typography'

const DetailsForm = () => {
  const vendorDetailsContext = useVendorDetailsContext()
  const detailsForm = useDetailsForm()
  const router = useRouter()

  const {
    form,
    isCreation,
    hasFormChanges,
    handleFinishForm,
    handleChangeForm,
    isActive,
    setIsActive,
    showRedirectModal,
    handleRedirectModal
  } = detailsForm

  const pushToPrevPage = () =>
    router.push(routes.myCommunity + '/' + MY_COMMUNITY_KEYS.vendors)
  const phoneNumber = Form.useWatch(['vendor', 'phone_number'], form)
  const canCreateOnlyGuestAccess = ability.can(
    ACTIONS.CREATE,
    SUBJECTS.ONLY_GUEST_VENDORS
  )

  const handleCloseRedirectModal = () => handleRedirectModal(false)

  return (
    <>
      <CustomForm<VendorDetailsForm>
        id="vendor-details-form"
        form={form}
        onChange={handleChangeForm}
        onFinish={handleFinishForm}
        validateMessages={validateMessages}
        initialValues={{
          vendor: {
            vendor_permission: canCreateOnlyGuestAccess
              ? 'guest'
              : 'full_access',
            address: {
              country: COUNTRIES_LIST[0].value
            }
          }
        }}
        onFieldsChange={() => setIsActive(true)}
        className="vendor-details__form"
      >
        <VendorForm
          phoneNumber={phoneNumber}
          form={form}
          disabled={!vendorDetailsContext.state.isCreation}
          isCreation={vendorDetailsContext.state.isCreation}
          errors={vendorDetailsContext.state.errors}
          getVendorError={(query) =>
            vendorDetailsContext.actions.getError(query)
          }
        />

        {(hasFormChanges || isCreation) && (
          <FloatFooter
            isActive={isActive}
            onCancel={pushToPrevPage}
            onSave={form.submit}
            isSaveDisabled={!isActive}
            saveBtnText={BTN_TXT.SAVE}
          />
        )}
      </CustomForm>
      <Popup
        visible={showRedirectModal}
        onCancel={handleCloseRedirectModal}
        title={'Assign vendor users?'}
        width={676}
        footer={
          <>
            <Button
              type={BUTTON_TYPES.DEFAULT}
              onClick={() => handleRedirectModal(false)}
              upperCase
            >
              {BTN_TXT.CREATE_WITHOUT_USERS}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={() => handleRedirectModal(true)}
              upperCase
            >
              {BTN_TXT.ASSIGN_USERS_NOW}
            </Button>
          </>
        }
      >
        <Typography.Body1>
          Adding Vendor users is optional. You can add them later. Without
          users, the Vendor cannot participate in RFPs or perform related
          actions.
        </Typography.Body1>
      </Popup>
    </>
  )
}

export default DetailsForm
